import { Component, Input } from '@angular/core';

@Component({
  selector: 'mz-datepicker-container',
  template: `<div
  class="input-field"
  [class.inline]="inline"
>
  <ng-content></ng-content>
</div>`,
  styles: [``],
})
export class MzDatepickerContainerComponent {
  @Input() inline: boolean;
}
